import React from "react";
import HeroSection from "../../components/Client/Landing/HeroSection";
import CategoryLayout from "../../components/Client/Landing/CategorySection/CategoryLayout";

// testimonial
import { clientsTestimonials } from "../../Data/Data";
import TestimonialSection from "../../components/Common/TestimonialSection";

// feature
import ServicesSection from "../../components/Common/ServicesSection";
import FeatureCardImg from "../../assets/landing/feature_card_img.png";
import { clientFeatures } from "../../constants/StringLitterels";

// how it works
import HowItWorksSection from "../../components/Common/HowItWorksSection";
import { clientWorkSteps } from "../../constants/StringLitterels";
import WorkStepImg from "../../assets/landing/image1.webp";
import WorkStepImg_LQ from "../../assets/landing/image1_lq.webp";
import FAQSection from "../../components/Tasker/FAQSection";
import { clientQuestions } from "../../constants/commonConstants";

const ClientHome = () => {
  return (
    <div className="w-full mt-12">
      {/* <div className="container mx-auto max-w-[1240px] px-4"> */}
      <div>
        <HeroSection />
        <div className="mt-10 md:mt-[88px]">
          <HowItWorksSection
            workSteps={clientWorkSteps}
            rightImage={WorkStepImg}
            rightImage_LQ={WorkStepImg_LQ}
          />
        </div>
        <div className="">
          <CategoryLayout />
        </div>
        <div className="">
          <ServicesSection
            navigationLink="/client/find-service-pro"
            buttonText="Find a Service-Pro"
            featureCardImg={FeatureCardImg}
            features={clientFeatures}
          />
        </div>
        {/* <div className="mt-10 md:mt-[88px] ">
          <TestimonialSection
            heading="Client Success Stories"
            testimonials={clientsTestimonials}
          />
        </div> */}
        {/* <div className="my-10 md:my-[108px]">
          <ConnectWithUs />
        </div> */}
        <div className="px-[20px] md:px-[40px] lg:px-[100px] pb-20 max-lg:pt-10 bg-white py-10 md:py-[88px]">
          <FAQSection questions={clientQuestions} />
        </div>
      </div>
    </div>
  );
};

export default ClientHome;
